var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_c('div', {
    class: _vm.$style.viewContainer
  }, [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('div', {
    staticClass: "mb-3",
    class: _vm.$style.appsHeader
  }, [!_vm.gridView ? _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('BaseTitle', [_vm._v("Apps")]), _c('span', {
    class: _vm.$style.linkAnchor,
    on: {
      "click": function click($event) {
        return _vm.activateGridView({
          label: 'about the apps'
        });
      }
    }
  }, [_vm._v(" About the apps ")])], 1) : _vm._e(), _vm.gridView ? _c('div', {
    class: _vm.$style.appBreadcrumbs
  }, [_c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.backButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "gray"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.activateCarouselView.apply(null, arguments);
      }
    }
  }), _c('p', {
    staticClass: "p2 color-darkest-gray cursor-pointer",
    on: {
      "click": _vm.activateCarouselView
    }
  }, [_vm._v("APPS")]), _c('BaseIcon', {
    staticClass: "color-gray",
    attrs: {
      "name": "chevron-right"
    }
  }), _c('p', {
    staticClass: "button-text color-primary-blue",
    class: _vm.$style.selectedBreadcrumb
  }, [_vm._v(" " + _vm._s(_vm.gridViewLabel.toUpperCase()) + " ")])], 1) : _vm._e()]), !_vm.gridViewSelectedCategory ? _c('div', [_c('CategorySelector', {
    attrs: {
      "categories": _vm.getDistinctCategories,
      "allow-empty": true,
      "show-all-button": true,
      "selected-category": _vm.selectedCategory
    },
    on: {
      "update:selectedCategory": function updateSelectedCategory($event) {
        _vm.selectedCategory = $event;
      },
      "update:selected-category": function updateSelectedCategory($event) {
        _vm.selectedCategory = $event;
      }
    }
  })], 1) : _vm._e(), _vm.carouselView ? _c('div', {
    class: _vm.$style.gridViewFavoriteApps
  }, [_c('h3', [_vm._v("Favorite " + _vm._s(_vm.selectedCategory) + " Apps")]), !_vm.filteredFavoriteApps.length ? _c('p', [_vm._v("Click the heart to favorite an app.")]) : _vm._e(), _c('transition-group', _vm._l(_vm.filteredFavoriteApps, function (app) {
    return _c('AppBlock', {
      key: app.appId,
      attrs: {
        "name": app.appName,
        "description": app.description,
        "category": app.category,
        "card-image": app.cardImage,
        "card-image-mobile": app.cardImageMobile,
        "app-url": app.appUrl,
        "app-id": app.appId
      }
    });
  }), 1)], 1) : _vm._e(), _vm.carouselView ? _c('div', {
    class: _vm.$style.carouselView
  }, _vm._l(_vm.getSelectedCategories, function (category) {
    return _c('AppCarousel', {
      key: category,
      class: _vm.$style.appCarousel,
      attrs: {
        "category": category,
        "apps": _vm.getAppsFromCategory(category)
      },
      on: {
        "openGridView": function openGridView($event) {
          return _vm.activateGridView({
            category: category
          });
        }
      }
    });
  }), 1) : _vm._e(), _vm.gridView ? _c('div', {
    class: (_class = {}, _class[_vm.$style.gridView] = true, _class[_vm.$style.gridViewWithDescription] = _vm.isAboutTheAppsSelected, _class)
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l(_vm.gridViewApps, function (app) {
    return _c('AppBlock', {
      key: app.appId,
      attrs: {
        "name": app.appName,
        "description": app.description,
        "category": app.category,
        "card-image": app.cardImage,
        "card-image-mobile": app.cardImageMobile,
        "app-url": app.appUrl,
        "app-id": app.appId,
        "options": {
          mobileCardSize: {
            width: '69',
            height: '69'
          },
          showHeart: false,
          showDescription: _vm.isAboutTheAppsSelected
        }
      }
    });
  }), 1)], 1) : _vm._e()])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }